import { Tabs, Tab } from "@mui/material";
import "./SidebarProject.css";

const SideBarProject = ({ value, handleChange }) => {
  const TabProps = (index) => {
    return {
      id: `sidebar-tab-${index}`,
      "aria-controls": `tabpanel-${index}`,
    };
  };
  return (
    <>
      <div className="pannel">
        <Tabs
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          sx={{ mt: 4, "&.MuiTabList-scrollButtons": { direction: "rtl" } }}
          textColor="inherit"
          orientation="horizontal"
          allowScrollButtonsMobile
          value={value}
          onChange={handleChange}
        >
          <Tab
            className="tabs"
            label="صنایع غذایی"
            {...TabProps(0)}
            sx={{ fontFamily: "Homa" }}
          ></Tab>
          <Tab
            className="tabs"
            label="صنایع دارویی و شیمیایی"
            {...TabProps(1)}
            sx={{ fontFamily: "Homa" }}
          ></Tab>
          <Tab
            className="tabs"
            label="صنایع نفت و گاز و پتروشیمی"
            {...TabProps(2)}
            sx={{ fontFamily: "Homa" }}
          ></Tab>
          <Tab
            className="tabs"
            label="سیلو"
            {...TabProps(3)}
            sx={{ fontFamily: "Homa", display: "flex", flexWrap: "wrap" }}
          ></Tab>
          <Tab
            className="tabs"
            label="عملیات حرارتی"
            {...TabProps(4)}
            sx={{ fontFamily: "Homa" }}
          ></Tab>
          <Tab
            className="tabs"
            label="صنایع نساجی"
            {...TabProps(5)}
            sx={{ fontFamily: "Homa" }}
          ></Tab>
          <Tab
            className="tabs"
            label="صنایع مختلف"
            {...TabProps(6)}
            sx={{ fontFamily: "Homa" }}
          ></Tab>
          <Tab
            className="tabs"
            label="پروژه های در دست اجرا"
            {...TabProps(7)}
            sx={{ fontFamily: "Homa" }}
          ></Tab>
        </Tabs>
      </div>
    </>
  );
};
export default SideBarProject;
